import PropTypes, { number } from 'prop-types'
import React from 'react'
import Link from 'next/link'

export const BreadCrumbsItem = ({ href, as, isLast, text }) => {
  return (
    <>
      {!isLast ? (
        <Link
          as={as}
          href={href}
        >
          <a className='vehicle-part-breadcrumbs__link'>
            {text}
          </a>
        </Link>
      ) : (
        <span className='vehicle-part-breadcrumbs__link vehicle-part-breadcrumbs__link--last'>
          {text}
        </span>
      )}

      {!isLast ? <span className='vehicle-part-breadcrumbs__separator--slash' /> : null}
    </>
  )
}

BreadCrumbsItem.propTypes = {
  as: PropTypes.string.isRequired,
  href: PropTypes.shape({
    pathname: PropTypes.string,
    query: PropTypes.object
  }).isRequired,
  isLast: PropTypes.bool,
  text: PropTypes.string
}
